import Api from "./Api";
import pSBC from "shade-blend-color";
import getCampaign from "hooks/useCampaign";
import Axios from "axios";
function fetchOverride() {
  console.log("running")
  if (!window.fetch || typeof window.fetch !== "function") return;
  const originalFetch = window.fetch;
  window.fetch = function () {
    const response = originalFetch.apply(this, arguments);

      console.log("fetch check", arguments[0])
    if (isShopifyCartURL(arguments[0])) {
      response.then((res) => {
        res
          .clone()
          .json()
          .then((data) => {
            console.log("fetch data")
            console.log(data)
          });
      });
    }

    return response;
  };
}

function XHROverride(setCartValue) {
  if (!XMLHttpRequest) {
    return
  
  };

  let open = XMLHttpRequest.prototype.open; 

  XMLHttpRequest.prototype.open = function () {
    const url = arguments[1];
    this.addEventListener("load", () => {
      if (isShopifyCartURL(url)) {
        const cart_items = JSON.parse(this.response).items
        let cartValue = 0
        cart_items.forEach(({final_line_price, vendor}) => {
          if(vendor !== 'Monster-ShipProtect'){
            cartValue += final_line_price
          }
        });
        setCartValue(cartValue)
      }
    });
    open.apply(this, arguments);
  };
}
const ShopifyCartURLs = [
  "/cart/add",
  "/cart/update",
  "/cart/change",
  "/cart/clear",
  "/cart/add.js",
  "/cart/update.js",
  "/cart/change.js",
  "/cart/clear.js",
  "cart.js"
];

function isShopifyCartURL(url) {
  if (!url) return false;
  const path = url.split("/").pop();
  return ShopifyCartURLs.includes(path);
}

export const getCartItems = async () => {
  // if(window.mu_cart_items) return window.mu_cart_items
  return new Promise((resolve, reject) => {
    Axios.get(`${window.location.origin}/cart.js`)
      .then(({ data: { items } }) => resolve(items))
      .catch(reject);
  });
};

export const watchCart = (setCartValue) => {
  XHROverride(setCartValue) 
  // fetchOverride()
}

export const watchChange = (action) => {
    window.addEventListener('mousedown', () => {
      action()
    })
};



export const getCartValue = async () => {
  const cart_items = await getCartItems();
  let cartValue = 0
  cart_items.forEach(({final_line_price, vendor}) => {
    if(vendor !== 'Monster-ShipProtect'){
      cartValue += final_line_price
    }
  });
  return cartValue
}



export const addProtection = async (variantId, status) => {
  return new Promise((resolve, reject) => {
    Axios.post(`${origin}/cart/${status ? "add": "change"}.js`, {
      quantity: status ? 1 : 0,
      id: variantId || window.monster_protection_variant+""
    })
      .then(({ data: { items } }) => resolve(items))
      .catch(reject);
  });
};










export const get_product_by_handle = (shop_url, product_handle) =>
  Api.get(
    `https://${shop_url}/products/${product_handle}.json?fields=variants`
  );

const formHasFile = (formData, variant_id) => {
  let hasFile = false;

  if (!formData) {
    return false;
  }
  const entriesIsFunction = typeof formData.entries === "function";

  const getEntries = () =>
    entriesIsFunction ? formData.entries() : formData.entries;
  for (const [name, type] of getEntries()) {
    if (type instanceof File) {
      hasFile = true;
      window.mu_form_files[variant_id] = [
        ...new Set(
          (window.mu_form_files[variant_id] || []).concat([
            name.replace("properties[", "").replace("]", "")
          ])
        )
      ];
      // localStorage.setItem(
      //   "mu_form_files",
      //   JSON.stringify(window.mu_form_files)
      // );
    }
  }
  return hasFile;
};
export const addToCart = (
  {
    variant_id,
    quantity,
    properties,
    selling_plan,
    currency,
    // props below are required for preview
    isPreview = false,
    shop_url = null,
    product_handle = null,
    product = null
  },
  formData
) => {
  const hasFile = formHasFile(formData, variant_id);
  if (isPreview) {
    variant_id = parseVariantId(variant_id);
    if (product) {
      const { id, image, title: product_title, variants } = product;
      const variant = variants.find(({ id }) => id === variant_id);
      const price = parseFloat((parseFloat(variant.price) * 100).toFixed(0));
      return Promise.resolve({
        ...variant,
        price,
        product_title,
        product_id: parseInt(id),
        image,
        quantity
      });
    }
    return new Promise((resolve, reject) => {
      get_product_by_handle(shop_url, product_handle)
        .then(({ data }) => {
          const { variants, title, images } = data.product;
          const variant = variants.find(
            ({ id }) => id === parseInt(variant_id)
          );
          const image = variant.image_id
            ? images.find(({ id }) => variant.image_id).src
            : data.product.image.src;
          const price = parseFloat(
            (parseFloat(variant.price) * 100).toFixed(0)
          );
          resolve({ ...variant, price, product_title: title, image, quantity });
        })
        .catch(reject);
    });
  } else {
    const { origin } = window.location;
    if (Array.isArray(variant_id)) {
      variant_id = variant_id.map(parseVariantId).filter((singleId) => !isNaN(singleId));
      if (variant_id.length == 1) variant_id = variant_id[0];

      if (variant_id.length == 0) return;
    }
    variant_id = parseVariantId(variant_id);
    return new Promise((resolve, reject) => {
      Api.post(
        `${origin}/cart/add.js?m=true&shop=${window.Shopify.shop}`,
        hasFile
          ? formData
          : Array.isArray(variant_id)
            ? {
              items: variant_id.map((singleId) => ({
                quantity,
                id: parseVariantId(singleId)
              }))
            }
            : {
              quantity,
              id: parseVariantId(variant_id),
              properties,
              selling_plan
            }
      )
        .then(({ data }) => {
          if (window.ttq) {
            window.ttq.track("AddToCart", {
              contents: [
                {
                  content_type: "product",
                  content_name: data.title,
                  content_id: data.product_id,
                  quantity: data.quantity,
                  price: data.price / 100
                }
              ],
              value: data.price / 100,
              currency
            });
          }

          let selectors = [".icon_cart .tcount"].concat(
            window.mu_bag_selecor || window.mu_bag_selector || []
          );
          Api.get(`${origin}/cart.js`).then(({ data }) => {
            selectors.forEach((selector) => {
              if (typeof selector === "function") {
                selector(data.item_count || 0)
              } else if (document.querySelectorAll(selector).length) {
                document.querySelectorAll(selector)[0].textContent =
                  data.item_count || 0;
              }
            });
          });
          // }
          resolve(data);
        })
        .catch(reject);
    });
  }
};

export const findItem = ({ line, items, variant_id }) => {
  return items.find(({ variant_id: id }, index) =>
    line ? line === index + 1 : id ? id.toString() === variant_id.toString() : false
  );
};

export const updateCartItem = ({
  variant_id,
  line,
  quantity,
  properties,
  selling_plan,
  isPreview = false,
  state = null
}) => {
  if (isPreview) {
    if (quantity === 0 && state.items.length === 1) {
      return Promise.resolve(state.items);
    }
    const stateCopy = { ...state };
    const newItems = stateCopy.items.map((item) => {
      if (item.id === variant_id) {
        return { ...item, quantity };
      }
      return item;
    });
    return Promise.resolve(newItems.filter(({ quantity }) => quantity > 0));
  } else {
    const { origin } = window.location;
    return new Promise((resolve, reject) => {
      Api.post(`${origin}/cart/change.js?m=true&shop=${window.Shopify.shop}`, {
        quantity,
        properties,
        selling_plan,
        id: line ? undefined : parseVariantId(variant_id).toString(),
        line
      })
        .then(({ data }) => {
          let selectors = [".icon_cart .tcount"].concat(
            window.mu_bag_selecor || window.mu_bag_selector || []
          );
          Api.get(`${origin}/cart.js`).then(({ data }) => {
            selectors.forEach((selector) => {
              if (typeof selector === "function") {
                selector(data.item_count || 0)
              } else if (document.querySelectorAll(selector).length) {
                document.querySelectorAll(selector)[0].textContent =
                  data.item_count || 0;
              }
            });
          });
          resolve(data.items);
        })
        .catch(reject);
    });
  }
};

export const getBundleDiscount = (
  { reward, type },
  quantity,
  price,
  money_format
) => {
  quantity = parseInt(quantity);
  reward = parseFloat(reward);
  const discounted = calculateDiscount({
    type,
    reward,
    total: price * quantity
  });
  return {
    plain: price * quantity - discounted,
    formatted: formatMoney(price * quantity - discounted, money_format),
    discounted
  };
};

export const sortByProp = (prop, order = "desc") => {
  return (array) => {
    return [...array].sort(function (a, b) {
      var x = a[prop];
      var y = b[prop];
      if (order === "desc") {
        return x > y ? -1 : x < y ? 1 : 0;
      } else {
        return y > x ? -1 : y < x ? 1 : 0;
      }
    });
  };
};

export const sortByQuantity = sortByProp("quantity");

export const calculateDiscount = ({ reward, type, total }) => {
  switch (type) {
    case "fixed_amount":
      return Math.abs(reward) * 100;
    case "percentage":
      return Math.floor((total * Math.abs(reward)) / 100);
    default:
      return 0;
  }
};

function formatWithDelimiters (
  number,
  precision = 2,
  thousands = ",",
  decimal = "."
) {
  if (isNaN(number) || number == null) {
    return 0;
  }

  number = (number / 100.0).toFixed(precision);

  var parts = number.split("."),
    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
    cents = parts[1] ? decimal + parts[1] : "";

  return dollars + cents;
}

export const formatMoney = (n, money_format = "${{amount}}", formatter = formatWithDelimiters) =>
  money_format
    .replace(/{{\s*?amount\s*?}}/g, formatter(n, 2))
    .replace(
      /{{\s*?amount_with_decimal_separator\s*?}}/g,
      formatter(n, 2)
    )
    .replace(/{{\s*?amount_no_decimals\s*?}}/g, formatter(n, 0))
    .replace(
      /{{\s*?amount_with_comma_separator\s*?}}/g,
      formatter(n, 2, ".", ",")
    )
    .replace(
      /{{\s*?amount_no_decimals_with_comma_separator\s*?}}/g,
      formatter(n, 0, ".", ",")
    )
    .replace(
      /{{\s*?amount_with_apostrophe_separator\s*? }}/g,
      formatter(n, 2, "'", ".")
    );

export const logError = (error) => {
  //log errors to bugSnag
  console.log("Monster error:", error);
};

export const productHasOneVariant = (product) => {
  const { variants } = product;
  return variants.length === 1;
  // return options.every(({ values }) => values.length === 1);
};

export const variantIsOnStock = (variant) => {
  const { inventory_management, inventory_quantity, inventory_policy } =
    variant;
  return inventory_management && inventory_policy === "deny"
    ? inventory_quantity >= 1
    : true;
};

export const parseProductId = (string) => {
  // example gid://shopify/ProductVariant/19566771404862
  const pattern = new RegExp("gid://shopify/Product/([0-9]+)$");
  if (pattern.test(string)) return parseInt(string.match(pattern)[1]);
  return string;
};

export const parseVariantId = (string) => {
  // example gid://shopify/ProductVariant/19566771404862
  const pattern = new RegExp("gid://shopify/ProductVariant/([0-9]+)$");
  if (pattern.test(string)) return parseInt(string.match(pattern)[1]);
  return string;
};

const add = (x, y) => x + y;

export const getTotal = (items) => {
  return items.length
    ? items.map(({ price, quantity }) => price * quantity).reduce(add)
    : 0;
};

export function sortBundles (bundles) {
  return [...bundles].sort((a, b) => a.quantity - b.quantity);
}
export function BundlesIndexMap (bundles) {
  return [...bundles].reduce((acc, cur, index) => {
    const { quantity } = cur;
    const next = bundles[index + 1];
    const quantityDeference = next ? next.quantity - quantity : 1;
    acc[quantity] = index;
    if (quantityDeference > 1) {
      for (let i = 1; i < quantityDeference; i++) {
        acc[quantity + i] = index;
      }
    }
    return acc;
  }, {});
}

export const extractContent = (s) => {
  var span = document.createElement("span");
  span.innerHTML = s;
  return span.textContent || span.innerText;
};

export const getCompareAtDiscount = ({ filteredItems, compareAtMap }) => {
  const compareAtDiscount = [...filteredItems].reduce((acc, { variant_id, price, quantity }) => {
    const compare_at = compareAtMap ? compareAtMap[variant_id] || price : price
    // const compare_at = compareAtMap && compareAtMap[variant_id] ? compareAtMap[variant_id] * parseFloat(window.Shopify.currency.rate) : price
    const discount = (compare_at - price) * quantity
    return acc + discount
  }, 0)
  return compareAtDiscount;
}

export const getDiscount = ({
  campaigns,
  items,
  total,
  filteredItems,
  filteredItemsTotal,
  discountCode,
  getBundlesOnly = false
}) => {
  if (discountCode) {
    return discountCode.value;
  }
  if (!campaigns || !Object.keys(campaigns).length) return 0;

  const calculatedCampaignsTypes = [];
  const bundlesDiscounts = [...items]
    .reverse()
    .reduce((acc, item) => {
      const { quantity, price, product_id } = item;
      const product_bundles_campaign = (campaigns[product_id] || []).find(
        ({ type }) => type === "bundles"
      );
      if (product_bundles_campaign) {
        const { bundles } = product_bundles_campaign;
        // const item = items.find((item) => item.product_id === product_id);
        // if (!item) return 0;
        const bundlesIndexMap = BundlesIndexMap(sortBundles(bundles.list));
        const maxQuantity = Math.max(
          ...Object.keys(bundlesIndexMap).map(Number)
        );
        let selectedBundle = bundlesIndexMap[quantity];
        if (selectedBundle === undefined && quantity > maxQuantity) {
          selectedBundle = bundlesIndexMap[maxQuantity];
        }
        const bundle = bundles.list[selectedBundle];
        const productTotal = quantity * price;
        const bundles_discount = bundle
          ? calculateReward(bundle, productTotal)
          : 0;
        acc += bundles_discount;
      }
      return acc;
    }, 0);
  if (getBundlesOnly) return bundlesDiscounts;
  const [add_to_unlock_product_id, add_to_unlock] = getCampaign("add_to_unlock")(campaigns, items);
  let atuDiscount = 0;
  const totalWithBundlesDiscount = filteredItemsTotal - bundlesDiscounts;
  const quantityCount = filteredItems.reduce((acc, cur) => {
    return acc + Number(cur.quantity);
  }, 0);
  if (
    add_to_unlock &&
    add_to_unlock?.isActive
  ) {
    const discounts = add_to_unlock.goals.filter(({ reward_type, goal }) => {
      let unlocked = false
      if (add_to_unlock.multi_goal_type === "amount") {
        unlocked = totalWithBundlesDiscount >= goal * 100 * parseFloat(window.Shopify.currency.rate)
      } else if (add_to_unlock.multi_goal_type === "quantity") {
        unlocked = quantityCount >= goal
      }
      return reward_type === "discount" && unlocked
    })
    atuDiscount = discounts.reduce((acc, cur) => {
      const add_to_unlock_discount = calculateReward(
        cur.discount,
        totalWithBundlesDiscount
      );
      if (add_to_unlock_discount > acc) {
        acc = add_to_unlock_discount
      }
      return acc
    }, 0)
  }
  //TODO: get the unlocked
  // const atuDiscount = [...filteredItems]
  //   .reverse()
  //   .reduce((acc, { quantity, product_id }) => {
  //     const product_atu_campaign = (campaigns[product_id] || []).find(
  //       ({ type }) => type === "add_to_unlock"
  //     );
  //     if (
  //       product_atu_campaign &&
  //       product_atu_campaign?.add_to_unlock?.isActive &&
  //       !calculatedCampaignsTypes.includes("add_to_unlock")
  //     ) {
  //       calculatedCampaignsTypes.push("add_to_unlock");
  //       const { add_to_unlock } = product_atu_campaign;
  //       const totalWithBundlesDiscount = filteredItemsTotal - bundlesDiscounts;
  //       let unlockedGoals;
  //       let unlocked = false;
  //       const sortedGoalsDesc = sortByProp("goal")(add_to_unlock.goals);
  //       if (add_to_unlock.multi_goal_type === "amount") {
  //         unlockedGoals = sortedGoalsDesc.filter(
  //           ({ goal }) => totalWithBundlesDiscount >= goal * 100
  //         );
  //       } else if (add_to_unlock.multi_goal_type === "quantity") {
  //         const quantityCount = filteredItems.reduce((acc, cur) => {
  //           return acc + Number(cur.quantity);
  //         }, 0);
  //         unlockedGoals = sortedGoalsDesc.filter(
  //           ({ goal }) => quantityCount >= goal
  //         );
  //       }
  //       if (unlockedGoals.length) {
  //         const distinct = [...new Set(unlockedGoals.map(({ reward_type }) => reward_type))]
  //         unlockedGoals.filter(({ reward_type }, index) => index === distinct.indexOf(reward_type)).forEach((goal) => {
  //           const { reward_type } = goal;
  //           const add_to_unlock_discount = calculateReward(
  //             goal[reward_type],
  //             totalWithBundlesDiscount
  //           );
  //           acc += add_to_unlock_discount;
  //         })
  //       }
  //     }
  //     return acc;
  //   }, 0);
  return bundlesDiscounts + atuDiscount;
};

export const getModules = (campaign, cart_settings) => {
  return campaign ? campaign.settings.modules : cart_settings.modules;
};

const calculateReward = ({ type, reward }, total) => {
  return Math.floor(calculateDiscount({ reward, type, total }));
};

const percentage = (partialValue, totalValue) => {
  return Math.floor((totalValue / 100) * partialValue);
};

const lightOrDark = (color) => {
  color = formatColor(color);
  var r, g, b, hsp;
  if (color.match(/^rgb/)) {
    color = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    );
    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"));
    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
  return hsp > 127.5 ? "light" : "dark";
};

export const formatColor = (color, alpha = null) =>
  !!color
    ? typeof color === "string"
      ? color
      : `rgba(${color?.r},${color?.g},${color?.b},${alpha || color?.a})`
    : undefined;

export function formatColorHex (color) {
  const { r, g, b } = color
  return "ddd"
}

export function RGBToHex (r, g, b) {
  r = r.toString(16);
  g = g.toString(16);
  b = b.toString(16);

  if (r.length == 1)
    r = "0" + r;
  if (g.length == 1)
    g = "0" + g;
  if (b.length == 1)
    b = "0" + b;

  return "#" + r + g + b;
}
export const colorAutoBlend = (percentage, color) => {
  switch (lightOrDark(color)) {
    case "light":
      return darkerColor(percentage, formatColor(color));
    case "dark":
      return lighterColor(percentage, formatColor(color));
  }
};
export const lighterColor = (percentage, color, blend = "#fff") => {
  color = formatColor(color);
  return pSBC(percentage, color, blend, true);
};
export const darkerColor = (percentage, color, blend = "#000") => {
  color = formatColor(color);
  return pSBC(-percentage, color, blend, true);
};

export const fakePreviewProducts = (price = "20.00", index = 0) => [
  {
    isExample: true,
    handle: "example-product",
    id: index.toString(),
    options: [
      {
        id: 0,
        product_id: index.toString(),
        name: "Title",
        position: 1,
        values: ["Default Title"]
      }
    ],
    images: [
      {
        src: "https://cdn.pixabay.com/photo/2017/01/25/17/35/picture-2008484_1280.png"
      }
    ],
    title: "Example product",
    variants: [
      {
        id: 1,
        product_id: index.toString(),
        image: null,
        price: price,
        featured_image: {
          src: "https://cdn.pixabay.com/photo/2017/01/25/17/35/picture-2008484_1280.png"
        },
        title: "Default Title",
        quantity: 20,
        inventory_policy: "continue",

        inventory_management: null,
        inventory_quantity: 1,
        old_inventory_quantity: 1
      }
    ],
    variant_id: 1
  }
];

export const em = (font_size) => `${font_size}em`;

export function hasParentWithMatchingSelector (target, selector) {
  return [...document.querySelectorAll(selector)].some(el =>
    el !== target && el.contains(target)
  )
}



export const setSubtotal = (value, currencyName) => {
  document.querySelectorAll(
  '.totals__total-value,'+
  't4s-cart__totalPrice,'+
  '.cart__subtotal + div,.cart-original-total,.cart__item-sub.cart__item-row div:last-child,' +
  '.checkout-button .money,' +
  '.totals__subtotal-value,.Cart__Checkout span:last-child,.Cart__Total span:first-child,' +
  '.cart-recap__price-line-price,.mini-cart__recap-price-line span:last-child,.subtotal span:first-child' +
  ',.cart-subtotal__price,.cart-subtotal span:last-child,.cart__total-container span:last-child'+
  ',.cart__footer-total span'+
  ',.ajaxcart__subtotal .money'+
  ',.subtotal .theme-money'+
  ',.cart__total__money'+
  ',#mini-cart-subtotal'+
  ',.btn--large .uppercase, .btn--long .uppercase, .btn--large.uppercase, .uppercase.btn--long span:first-child'+
  ',.cart__footer-page .cart__item-row .h3 span:last-child'+
  ',.cart-total-price'+
  ',.justify-between .ml-2'+
  ',.quick-cart__total .fs-body-bold'+
  ',.cart-summary__subtotal .amount .theme-money'+
  ',.cart__footer-right .fs-heading-4-base'+
  ',[data-cart-footer] .border-t-section .grid-cols-14 .grid-cols-2 dd'+
  ',.cart--total--price'+
  ',.standard-title .theme-money'+
  ',.cart-summary__total-price-row .theme-money'+
  ',.cart-template__footer-info .type-body-extra-large'+
  ',.quick-cart__footer .js-subtotal'+
  ',.mini-cart__total .amount'+
  ',[data-cart-final]'+
  ',.price-preview #total-cart-bottom'+
  ',.cartTotalSelector'+
  ',[data-aid=\'cart-summary-info\'] [data-aid=\'regular-price\']'+
  ',.align-center-mobile span.theme-money'+
  ',.cart-block__subtotal .subtotal__price'+
  ',.cart-button__total'+
  ',#CartTotal>span:first-child'+
  ',.\\#cart-subtotal-item-price'+
  ',.\\#cart-notification-summary-total'+
  ',.cart__subtotal-price'+
  ',.totals__subtotal-value'+
  ',.gocheckout .subtotal c strong'+
  ',.cart__total-count'+
  ',.grid--full .one-third p'+
  ',[data-cart-total-price]'+
  ',.tw-text-center .cart-price'+
  ',.more>h3.row>span.value'+
  ',.\\#cart-checkout-subtotal-value'+
  ',.ajax-cart__header-wrapper .cart-title'+
  ',.cart-total-line--total span.money'+
  ',.mini-cart__total span.amount'+
  ',.cart-subtotal .price'+
  ',.quick-cart__footer-subtotal span.ff-body'+
  ',.js-contents-foot .cart-items__total span:last-child'+
  ',[data-cart-total]'+
  ',.cart-mini-subtotal-value'+
  ',.cart-drawer__cart-total .money'+
  ',[data-subtotal]:not(form)'+
  ',.cart__footer-right p.fs-heading-base'+
  ',.cart--external--total-price'+
  ',.cart-details #CartTotal strong'+
  ',.subtotal_amount span.money'+
  ',[data-total-price]'+
  ',.cart-totals .cart-price'+
  ',.js-cart-item-price'+
  ',#mini-cart-totals span:last-child'+
  ',#main-cart-footer .totals-subtotal-value'+
  ',.cart-template__footer-details .cart__subtotal'+
  ',.subtotal-row .subtotal-amount .theme-money'+
  ',.text-right [data-price]'+
  ',.cart-summary-line .barracuda span:last-child'+
  ',.cart__total .text-size--heading'+
  ',[data-header-cart-total]'+
  ',[data-cart-subtotal-price]' +
  ',#StickySubtotal' +
  ',#cart-total-final-price .money' +
  ',.h3.cart__subtotal .money,' +
  'tr.total .card-total-price,' +
  '.drawer__footer p.ajaxcart__price,' +
  '.minicart-footer .minicart-subtotal,' +
  '.cart-subtotal p.cart-subtotal-price,' +
  // '.mu-subtotal span:last-child,'+
  '[data-cart-total-price],.yv-side-drawer-container .bottom-cart-box .totle-price .h4,'+
  '[data-cart-price],#cart-drawer div.h-stack.gap-4.justify-between span.h5:last-child,'+
  '#main .cart-order__recap div.h-stack.gap-4.justify-between span.h5:last-child'+'.cart__checkout'+
  ',[data-tbnadhide="HAS_DISCOUNT"]'+',[data-tbnadhide="NO_DISCOUNT"] s span' +
  ',.slidecart-subtotal' +
  ',.tt-cart-total-price, #grandtotal td' +
  ',.revy-bundle-result-price .money' +
  ',#CartSubtotal' +
  ',.cart__subtotal' +
  ',.u-margin-b-sm p.h4' +
  ',.right .t-uppercase .money' +
  ',.shopping-cart__total' +
  ',.rebuy-cart__flyout-subtotal-amount' +
  ',.cart-footer .total_price'
  ).forEach(item=>{
    item.innerHTML = value +' '+currencyName;
  })
}